import React from 'react';

const TabsRenderProp = (props) => {
  return (
    <div className="tab">
      <h3 className="tab__header"> {props.header()}</h3>
      <div className="tab__content">
        {props.content()}
      </div>
    </div>
  )
}

export default TabsRenderProp;




// WEBPACK FOOTER //
// ./src/components/TabsRenderProp.js